import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, _common) => ({
  tagContainer: {
    fontSize: 10,
    color: theme.palette.background.paper,
    display: 'inline-block',
    padding: '0 3px',
    borderRadius: 2,
    '&.primary': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.grey': {
      backgroundColor: theme.palette.grey[500],
    },
    '&.error': {
      backgroundColor: theme.palette.error.main,
    },
  },
}));

export type FeatureTagColor = 'primary' | 'grey' | 'error';

export interface FeatureTagProps {
  color: FeatureTagColor;
}

export const FeatureTag: React.FC<React.PropsWithChildren<FeatureTagProps>> = (props) => {
  const { color, children } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return <span className={clsx(classes.tagContainer, color)}>{children}</span>;
};
